var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let foreignRouteState;
function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function (k) {
        if (k === 'configure' || k === 'query' || k === 'q') {
            return;
        }
        trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
}
/**
 * List of URL params which are "allowed" by InstantSearch.
 * These parameters won't be overwritten when the search state is written
 * to the URL.
 */
const ALLOWED_FOREIGN_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
function singleIndex(indexName) {
    return {
        /**
         * `stateToRoute` method transforms the `uiState` object from InstantSearch
         * into an object that will then be serialized to construct the URL.
         */
        stateToRoute: function (uiState) {
            let route = getTrackedUiState(uiState[indexName] || {});
            route.q = uiState[indexName].query;
            return Object.assign({}, foreignRouteState, route);
        },
        /**
         * `routeToState` method transforms the route object into a `uiState` object
         * so that InstantSearch is initialized with the correct state from the
         * URL.
         */
        routeToState: function (routeState) {
            /**
             * Backup parameters from `routeState` into a different object
             * `foreignRouteState` so that we can re-inject them into the object
             * returned within `stateToRoute`.
             * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
             * array.
             */
            if (!foreignRouteState) {
                foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function (acc, key) {
                    acc[key] = routeState[key];
                    return acc;
                }, {});
            }
            let state = {};
            state[indexName] = getTrackedUiState(routeState || {});
            state[indexName].query = routeState.q;
            return state;
        },
    };
}
export const algoliaConfig = () => {
    const algolia = globalThis.algoliaShopify;
    const config = algolia.config;
    const appId = config.app_id;
    const apiKey = config.search_api_key;
    const index_prefix = config.index_prefix;
    return { algolia, config, appId, apiKey, index_prefix };
};
export const algoliaSearchClient = () => __awaiter(void 0, void 0, void 0, function* () {
    const algolia = globalThis.algoliaShopify;
    const { default: algoliasearch } = yield import(/* webpackChunkName: 'AlgoliaSearch' */ 'algoliasearch');
    const searchClient = algoliasearch(algolia.config.app_id, algolia.config.search_api_key);
    if (!globalThis.algoliaShopify.instantsearch) {
        globalThis.algoliaShopify.instantsearch = algolia.externals.instantsearch({
            searchClient,
            indexName: algolia.config.index_prefix + 'products',
            routing: {
                stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
            },
            searchFunction: function () { },
        });
    }
    return searchClient;
});
export const algoliaRecommendClient = () => __awaiter(void 0, void 0, void 0, function* () {
    const algolia = globalThis.algoliaShopify;
    const { default: recommend } = yield import(/* webpackChunkName: 'AlgoliaRecommend' */ '@algolia/recommend');
    return recommend(algolia.searchClient.applicationID, algolia.searchClient.apiKey);
});
export const GetAlgoliaClientExternalsOnly = () => {
    const algolia = globalThis.algoliaShopify;
    const config = globalThis.algoliaShopify.config;
    const appId = config.app_id;
    const apiKey = config.search_api_key;
    const searchClient = globalThis.algoliaShopify.searchClient;
    const instantsearch = algolia.externals.instantsearch({
        searchClient,
        indexName: algolia.config.index_prefix + 'products',
        routing: {
            stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
        },
        searchFunction: function () { },
    });
    return {
        appId,
        apiKey,
        config,
        algolia: Object.assign(Object.assign({}, algolia), { searchClient, instantsearch }),
        search: instantsearch.client,
    };
};
